import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectUser } from 'main/store/common/selectors';
import { DISABLE_AUTHENTICATION } from 'main/utils/constants';

export const PrivateRoute = () => {
    const location = useLocation();
    const user = useSelector(selectUser);

    return !!user || DISABLE_AUTHENTICATION ?
        <Outlet /> :
        <Navigate to="/sign-in" replace state={location} />
}
